import template from './formActions.html';
import controller from './formActions.controller';
import './formActions.scss';

let formActionsComponent = {
  restrict: 'E',
  bindings: {
    cancelTarget: '@',
    cancelTargetParams: '@',
    saveLabel: '@',
    save: '&',
    clearAction: '&',
    formClear: '='
  },
  template,
  controller
};

export default formActionsComponent;
